<template>
  <q-modal
      v-model="opened"
      :noBackdropDismiss="edit"
      position="bottom"
      @hide="stopAll"
      @show="hideLoading"
      :maximized="contentType === 'geo'"
      content-classes="panel mediator"
  >
    <div class="panel-header">
      <q-resize-observable @resize="onResize1" />
      <div class="panel-title">
        <span>
          {{title}}
        </span>
        <small class="text-grey-6">
          {{fileName}} ({{contentType}}), {{fileSize | formatSize}}
        </small>
        <span class="text-warning">
          {{groupMessage}}
        </span>
      </div>
      <template v-if="!edit && editEnabled">
        <q-btn
            @click="doDelete"
            color="negative"
            icon="delete"
            small
            round
            flat
            title="Удалить в корзину"
        />
        <q-btn @click="edit=true" color="warning" icon="edit" small round flat title="Изменить" />
      </template>
      <q-btn
          v-if="!edit && contentType === 'application/pdf'"
          color="positive"
          small
          round
          flat
          title="Смотреть"
      >
        <a :href="url" target="_blank" style="text-decoration: none">
          <q-icon name="visibility" color="positive" />
        </a>
      </q-btn>
      <q-btn
          v-if="!edit && contentType !== 'geo'"
          color="positive"
          small
          round
          flat
          title="Скачать"
      >
        <a :href="url" :download="name" style="text-decoration: none">
          <q-icon name="file_download" color="positive" />
        </a>
      </q-btn>
      <q-btn @click="doCancel" title="Закрыть" color="primary" icon="clear" small round flat />
      <q-btn
          v-if="edit"
          @click="doSave"
          :disabled="notChanged"
          color="positive"
          icon="done"
          small
          round
          flat
          title="Сохранить"
      />
    </div>
    <div class="panel-body">
      <div>
        <q-resize-observable @resize="onResize2" />
        <template v-if="edit">
          <q-field
            :error="$v.name.$error"
            :error-label="$v.name | errorLabel"
          >
            <q-input float-label="Название" v-model.trim="name" />
          </q-field>
          <q-field>
            <q-input type="textarea" float-label="Описание" v-model.trim="comment" :rows="1"/>
          </q-field>
          <div class="row justify-between">
            <q-checkbox
                v-if="contentType != 'geo'"
                v-model="dND"
                label="Доступно оффлайн (на этом устройстве)"
            />
            <q-btn
                icon="crop_rotate"
                v-if="editableFormat"
                @click="doCropRotate"
                color="primary"
                small
                round
                flat
                title="Обрезать/повернуть"
            />
          </div>
        </template>
        <template v-else>
          <p v-if="comment">
            <span>{{comment}}</span>
          </p>
        </template>
      </div>
      <pic-resize
        v-if="(contentType.indexOf('image') === 0) && opened"
        v-model="blob"
        :maxHeight="picMaxHeight"
        :url="url"
        :picIniSize="fileSize"
        :editableFormat="editableFormat"
        :maxQuality="maxQuality"
      />
      <video
          v-if="contentType.indexOf('video') === 0"
          :style="{ maxHeight: maxHeight }"
          :src="url"
          controls
          id="v"
          :autoplay="!edit"
      >
      </video>
      <audio
          v-if="contentType.indexOf('audio') === 0"
          :src="url"
          controls
          id="a"
          :autoplay="!edit"
      >
      </audio>
      <div v-if="contentType === 'geo'" id="map" :style="{ height: maxHeight }"></div>
    </div>
    <slim-cropper :options="slimOptions" ref="slim" :data="file" v-if="slimShow"/>
  </q-modal>
</template>
<style scoped>
  video, audio {
    max-width: 100%;
  }
  #map {
    width: 100%;
  }
</style>
<script type="text/babel">
import _ from 'lodash';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import { Loading } from 'quasar';
import PicResize from 'components/pic-resize.vue';
import SlimCropper from 'components/slim.vue';

export default {
  name: 'mediator',
  components: {
    PicResize,
    SlimCropper,
  },
  props: {
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: false,
      maxQuality: 101, // 101 means picture not changed
      file: null,
      fileSize: null,
      blob: null,
      fileName: '',
      mediaId: '',
      contentType: '',
      name: '',
      comment: '',
      dND: false, // doNotDelete
      iniName: '',
      iniComment: '',
      iniDND: false,
      url: '',
      mapInfo: {},
      iniMapInfo: {},
      map: null,
      marker: null,
      opened: false,
      slimShow: false,
      height1: 0,
      height2: 0,
      left: 0, // how much medias left
      slimOptions: {
        instantEdit: true,
        push: true,
        didCancel: this.slimCancel,
        service: this.slimService,
        serviceFormat: 'file',
        buttonConfirmLabel: 'Сохранить',
        buttonCancelLabel: 'Отменить',
        buttonConfirmTitle: 'Сохранить',
        buttonCancelTitle: 'Отменить',
        buttonRotateTitle: 'Повернуть',
      },
    };
  },
  validations: {
    name: {
      required: withParams({ message: 'Введите название' }, required),
    },
  },
  computed: {
    editableFormat() { // if editable picture (new .jpeg, .bmp, .gif or .png media) return image format else return null
      let f;
      if (this.mediaId) { // existing media
        return null;
      } else if (this.contentType) {
        f = this.contentType.split('/')[1];
      } else if (this.fileName) {
        f = this.fileName.split('.')[1].replace('jpg', 'jpeg');
      }
      if (f === 'jpeg' || f === 'png' || f === 'bmp' || f === 'gif') {
        return f;
      }
      return null;
    },
    picMaxHeight() {
      return (0.8 * this.$store.state.pageHeight) - this.height1 - this.height2 - 35;
    },
    maxHeight() {
      return `${this.picMaxHeight}px`;
    },
    groupMessage() {
      return this.left ? `[и еще ${this.left}]` : '';
    },
    notChanged() {
      return (this.iniName === this.name) && (this.iniComment === this.comment)
        && (this.iniDND === this.dND) &&
          ((this.contentType !== 'geo') || _.isEqual(this.iniMapInfo, this.mapInfo));
    },
    title() {
      const what = (this.contentType === 'geo') ? 'место' : 'вложение';
      return this.mediaId ? (this.edit ? `Изменить ${what}` : this.name) : `Прикрепить ${what}`;
    },
  },
  watch: {
    edit(val) {
      if (this.marker) {
        this.marker.setDraggable(val);
      }
    },
  },
  methods: {
    doCropRotate() {
      console.log('doCropRotate media');
      this.slimShow = true;
    },
    onResize1(size) {
      // console.log('onResize1', size.height);
      this.height1 = size.height;
    },
    onResize2(size) {
      // console.log('onResize2', size.height);
      this.height2 = size.height;
    },
    init(media, edit, left = 0) {
      Loading.show();
      this.blob = null;
      this.maxQuality = 101; // unchanged picture
      console.log('init', media);
      this.edit = !!edit;
      this.left = left;
      this.contentType = media.contentType;
      this.iniName = media.name || '';
      this.name = this.iniName;
      this.iniComment = media.comment || '';
      this.comment = this.iniComment;
      this.iniDND = !!media.dND;
      this.dND = this.iniDND;
      if (media.contentType === 'geo') {
        const it = this;
        console.log('geo');
        this.mediaId = media.id || null;
        this.file = null;
        this.opened = true;
        this.mapInfo = Object.assign({}, media.mapInfo);
        this.iniMapInfo = Object.assign({}, media.mapInfo);
        setTimeout(() => {
          const el = document.getElementById('map');
          console.log(el);
          it.map = new window.google.maps.Map(el, {
            zoom: media.mapInfo.zoom,
            center: { lat: media.mapInfo.center.lat, lng: media.mapInfo.center.lng },
          });
          it.marker = new window.google.maps.Marker({
            position: { lat: media.mapInfo.place.lat, lng: media.mapInfo.place.lng },
            map: it.map,
            draggable: it.edit,
          });
          it.map.addListener('center_changed', () => {
            Vue.set(it.mapInfo, 'center', it.map.getCenter().toJSON());
          });
          it.map.addListener('zoom_changed', () => {
            Vue.set(it.mapInfo, 'zoom', it.map.getZoom());
          });
          it.marker.addListener('position_changed', () => {
            Vue.set(it.mapInfo, 'place', it.marker.getPosition().toJSON());
          });
        }, 100);
      } else if (media.id) { // existing media not geo
        this.fileName = '';
        this.fileSize = media.file_size;
        this.mediaId = media.id;
        console.log('existing media mediaId =', this.mediaId);
        const it = this;
        this.$store.dispatch('getAttachment', this.mediaId)
          .then((blob) => {
            console.log('existing media');
            it.file = blob;
            it.url = URL.createObjectURL(it.file);
            console.log('this.mediaId 2', it.mediaId, it.title);
            it.opened = true;
          })
          .catch((err) => {
            console.log('MEDIATOR getAttachment error', err);
            Loading.hide();
            if (err.status === 404) {
              this.$emit('mediaDeleted', { id: it.mediaId }); // silently delete link to missed media
            }
          });
      } else if (media.file) { // new media not geo
        console.log('new media');
        this.mediaId = null;
        this.file = media.file;
        this.fileName = media.file.name;
        this.fileSize = media.file.size;
        this.url = URL.createObjectURL(media.file);
        this.opened = true;
      } else {
        Loading.hide();
        console.log('ERROR -- No correct media provided!');
      }
    },
    hideLoading() {
      Loading.hide();
    },
    stopAll() {
      console.log('****************** STOP ALL ****************************');
      this.$v.name.$reset();
      const a = document.getElementById('a');
      const v = document.getElementById('v');
      if (a) a.pause();
      if (v) v.pause();
      if (this.map) window.google.maps.event.clearInstanceListeners(this.map);
      if (this.marker) window.google.maps.event.clearInstanceListeners(this.marker);
      if (this.left) {
        this.$emit('doNext'); // process next mediaFile
      }
    },
    download(e) {
      console.log(e);
    },
    slimCancel() {
      console.log('slimCancel');
      this.slimShow = false;
    },
    slimService(formdata, progress, success, failure, slim) {
      console.log('slimService');
      console.log('rotation', slim._data.actions.rotation);
      console.log('input', slim._data.input.height, slim._data.input.width);
      console.log('output', slim._data.output.height, slim._data.output.width);
      const changed = () => {
        if (slim._data.actions.rotation > 0) return true;
        if (Math.abs(slim._data.input.height - slim._data.output.height) > 3) return true;
        if (Math.abs(slim._data.input.width - slim._data.output.width) > 3) return true;
        return false;
      };
      if (changed()) {
        this.file = formdata[0];
        this.url = URL.createObjectURL(this.file);
        this.fileSize = this.file.size;
        this.maxQuality = 100; // picture changed
      } else {
        console.log('********** picture not changed ************');
      }
      this.slimShow = false;
    },
    doDelete() {
      const it = this;
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: `Вложение ${it.name} будет удалено в корзину!`,
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          this.opened = false;
          it.$emit('mediaDeleted', { id: it.mediaId });
        })
        .catch(() => {
        });
    },
    doCancel() {
      this.opened = false;
    },
    doSave() {
      const it = this;
      this.$v.name.$touch();
      if (this.$v.name.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.contentType === 'geo') { // geopoint
        this.opened = false;
        if (!this.mediaId) { // new geopoint
          const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
          const mediaId = `x:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
          it.$emit('mediaEdited', {
            id: mediaId,
            contentType: 'geo',
            mapInfo: it.mapInfo,
            name: it.name,
            comment: it.comment,
          });
        } else {
          it.$emit('mediaEdited', {
            id: it.mediaId, mapInfo: it.mapInfo, name: it.name, comment: it.comment,
          });
        }
      } else if (!this.mediaId) { // new media not geopoint
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        const mediaId = `x:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
        this.$store.dispatch('saveUnit', {
          _id: mediaId,
          dnd: it.dND,
          saved: false, // saved on server
          _attachments: {
            media: {
              content_type: it.blob ? it.blob.type : it.contentType,
              data: it.blob ? it.blob : it.file,
            },
          },
        })
          .then(() => {
            this.opened = false;
            it.$emit('mediaEdited', {
              id: mediaId,
              file_size: it.blob ? it.blob.size : it.fileSize,
              contentType: it.blob ? it.blob.type : it.contentType,
              name: it.name,
              comment: it.comment,
            });
          })
          .catch((err) => {
            console.log('err', err);
            it.$store.commit('pushError', err);
          });
      } else if (it.iniDND !== it.dND) { // not geo existing media and change doNotDelete
        (function bar() {
          if (it.$store.state.offMedias[it.mediaId]) { // is in dataDB
            if (it.dND) { // turn on
              return it.$store.dispatch('saveUnit', Object.assign({}, it.$store.state.offMedias[it.mediaId], { dnd: true }));
            } // turn off
            if (it.$store.state.offMedias[it.mediaId].saved) {
              return it.$store.dispatch('deleteUnit', it.$store.state.offMedias[it.mediaId]);
            }
            return it.$store.dispatch('saveUnit', Object.assign({}, it.$store.state.offMedias[it.mediaId], { dnd: false }));
          } // not in dataDB
          if (it.dND) { // turn on
            return it.$store.dispatch('saveUnit', {
              _id: it.mediaId,
              dnd: true,
              saved: true,
              _attachments: {
                media: {
                  content_type: it.contentType,
                  data: it.file,
                },
              },
            });
          }
        }())
          .then(() => {
            this.opened = false;
            it.$emit('mediaEdited', { id: it.mediaId, name: it.name, comment: it.comment });
          })
          .catch((err) => {
            console.log('err', err);
            it.$store.commit('pushError', err);
          });
      } else { // existing media
        this.opened = false;
        it.$emit('mediaEdited', { id: it.mediaId, name: it.name, comment: it.comment });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mediator.vue